<template>
  <div class="course-schedule-display-container">
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>我的日程（VIP）</span>
          </div>
          <el-form
            :inline="true"
            :model="searchForm"
            class="search-form text-left"
          >
            <el-form-item>
              <el-select
                v-model="searchForm.week"
                placeholder="请选择周次"
                clearable
                style="width: 120px"
              >
                <el-option
                  v-for="item in weekOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select
                v-model="searchForm.weekday"
                placeholder="请选择星期"
                clearable
                style="width: 100px"
              >
                <el-option
                  v-for="item in weekdayOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="searchForm.courseName"
                placeholder="请输入日程名称"
                clearable
                style="width: 200px"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleSearch"> 查询 </el-button>
              <el-button @click="handleReset"> 重置 </el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="24">
        <el-card class="schedule-card">
          <div class="schedule-title">我的日程</div>
          <!-- 日程可视化展示 -->
          <div class="schedule-calendar" v-loading="loading">
            <!-- 顶部日期栏 -->
            <div class="calendar-top-header">
              <div class="week-number-cell">
                第{{ searchForm.week.replace("第", "").replace("周", "") }}周
              </div>
              <div
                class="day-header-cell"
                v-for="day in weekdayOptions"
                :key="day.value"
              >
                <div class="day-name">{{ day.label }}</div>
                <div class="day-date">
                  08-{{
                    19 +
                    weekdayOptions.findIndex((item) => item.value === day.value)
                  }}
                </div>
              </div>
            </div>

            <div class="calendar-body">
              <div
                class="time-row"
                v-for="section in sectionOptions"
                :key="section.value"
              >
                <div class="time-cell">
                  <div class="section-number">{{ section.value }}节</div>
                  <div class="section-time">
                    {{ section.label.split("(")[1].replace(")", "") }}
                  </div>
                </div>
                <div
                  class="course-cell"
                  v-for="day in weekdayOptions"
                  :key="day.value"
                >
                  <!-- 核心修复：使用template包裹v-for，彻底分离v-for和v-if -->
                  <template v-for="course in mergedCoursesByWeekday[day.value]">
                    <div
                      :key="`${course.id}-${day.value}-${course.startSection}`"
                      class="course-block"
                      v-if="course.startSection === Number(section.value)"
                      :style="{
                        backgroundColor: course.courseColor || '#f9f9f9',
                        color: getTextColor(course.courseColor || '#f9f9f9'),
                        height: `${course.sectionCount * 80}px`,
                        borderRadius: '8px',
                        zIndex: 10,
                        cursor: 'pointer',
                      }"
                      @click="openCourseDetail(course)"
                    >
                      <div class="course-name">{{ course.courseName }}</div>
                      <div class="course-code">{{ course.room || "" }}</div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>

          <!-- 日程列表（备用） -->
          <div class="schedule-list" style="margin-top: 20px">
            <el-table :data="tableData" border style="width: 100%" stripe>
              <el-table-column
                prop="week"
                label="周次"
                align="center"
                width="100"
              ></el-table-column>
              <el-table-column
                prop="weekday"
                label="星期"
                align="center"
                width="100"
              ></el-table-column>
              <el-table-column
                prop="section"
                label="时段"
                align="center"
                min-width="200"
              >
                <template slot-scope="scope">
                  <el-tag
                    v-for="sec in scope.row.section.split(',')"
                    :key="sec"
                    size="mini"
                    style="
                      margin: 2px;
                      background: #e6f7ff;
                      color: #1890ff;
                      border: 1px solid #91d5ff;
                    "
                  >
                    {{ getSectionLabel(sec) }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                prop="courseName"
                label="日程名称"
                align="center"
                min-width="200"
              ></el-table-column>
              <el-table-column
                prop="room"
                label="会议地点"
                align="center"
                min-width="150"
              ></el-table-column>
              <el-table-column label="日程颜色" align="center" width="120">
                <template slot-scope="scope">
                  <div
                    class="color-block"
                    :style="{
                      backgroundColor: scope.row.courseColor || '#e0e0e0',
                    }"
                  ></div>
                </template>
              </el-table-column>
            </el-table>

            <el-pagination
              :current-page.sync="page.current"
              :page-size="page.size"
              :total="page.total"
              layout="total, sizes, prev, pager, next, jumper"
              style="margin-top: 20px; text-align: right"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 日程详情弹窗 -->
    <el-dialog
      title="日程详情"
      :visible.sync="detailDialogVisible"
      width="600px"
      :close-on-click-modal="false"
      center
    >
      <div v-if="currentCourse" class="course-detail-content">
        <el-descriptions :column="1" border style="margin-bottom: 16px">
          <el-descriptions-item label="会议名称">
            {{ currentCourse.courseName || "无" }}
          </el-descriptions-item>
          <el-descriptions-item label="会议周次">
            {{ currentCourse.week || "无" }}
          </el-descriptions-item>
          <el-descriptions-item label="会议星期">
            {{ currentCourse.weekday || "无" }}
          </el-descriptions-item>
          <el-descriptions-item label="会议时间">
            {{ getCourseTimeText(currentCourse) }}
          </el-descriptions-item>
          <el-descriptions-item label="会议地点">
            {{ currentCourse.room || "无" }}
          </el-descriptions-item>
          <el-descriptions-item label="参会人员">
            {{ currentCourse.participants || "无" }}
          </el-descriptions-item>
          <el-descriptions-item label="备注">
            {{ currentCourse.remark || "无" }}
          </el-descriptions-item>
          <el-descriptions-item label="附件">
            <div v-if="currentCourse.url" class="attachment-item">
              <el-link
                type="primary"
                @click="downloadAttachment(currentCourse)"
                icon="el-icon-download"
              >
                {{ getFileName(currentCourse.url) || "会议附件" }}
              </el-link>
            </div>
            <span v-else style="color: #999">无附件</span>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCourseScheduleList } from "@/api/contract/courseScheduleApi";
import { getCommunityId } from "@/api/community/communityApi";

export default {
  name: "CourseScheduleDisplay",
  data() {
    return {
      loading: false,
      // 搜索表单
      searchForm: {
        week: "第1周",
        weekday: "",
        courseName: "",
      },
      // 下拉选项
      weekOptions: [
        { label: "第1周", value: "第1周" },
        { label: "第2周", value: "第2周" },
        { label: "第3周", value: "第3周" },
        { label: "第4周", value: "第4周" },
        { label: "第5周", value: "第5周" },
        { label: "第6周", value: "第6周" },
      ],
      weekdayOptions: [
        { label: "周一", value: "周一" },
        { label: "周二", value: "周二" },
        { label: "周三", value: "周三" },
        { label: "周四", value: "周四" },
        { label: "周五", value: "周五" },
        { label: "周六", value: "周六" },
        { label: "周日", value: "周日" },
      ],
      sectionOptions: [
        { label: "时段(08:30-09:10)", value: "1" },
        { label: "时段(09:15-09:55)", value: "2" },
        { label: "时段(10:10-10:50)", value: "3" },
        { label: "时段(10:55-11:35)", value: "4" },
        { label: "时段(11:40-12:20)", value: "5" },
        { label: "时段(12:25-13:05)", value: "6" },
        { label: "时段(13:30-14:10)", value: "7" },
        { label: "时段(14:15-14:55)", value: "8" },
        { label: "时段(15:00-15:40)", value: "9" },
        { label: "时段(15:45-16:25)", value: "10" },
      ],
      // 表格数据
      tableData: [],
      // 分页参数
      page: {
        current: 1,
        size: 10,
        total: 0,
      },
      communityId: "",
      // 详情弹窗相关
      detailDialogVisible: false,
      currentCourse: null,
    };
  },
  computed: {
    /**
     * 计算属性：按星期分组的合并后日程数据
     * 修复 vue/no-use-v-if-with-v-for 警告
     */
    mergedCoursesByWeekday() {
      // 初始化每个星期的日程数组
      const result = {};
      this.weekdayOptions.forEach((day) => {
        result[day.value] = [];
      });

      // 过滤当前周的日程并按星期分组
      const currentWeekCourses = this.tableData.filter(
        (item) => item.week === this.searchForm.week,
      );

      // 处理每个日程，计算合并信息
      currentWeekCourses.forEach((course) => {
        const sections = course.section.split(",").map(Number);
        const mergedCourse = {
          ...course,
          startSection: Math.min(...sections),
          endSection: Math.max(...sections),
          sectionCount: sections.length,
        };

        // 添加到对应星期的数组中
        if (result[course.weekday]) {
          result[course.weekday].push(mergedCourse);
        }
      });

      return result;
    },
  },
  created() {
    this.communityId = getCommunityId() || "";
    this.getList();
  },
  methods: {
    /**
     * 获取日程列表
     */
    async getList() {
      try {
        this.loading = true;
        const params = {
          page: this.page.current,
          row: this.page.size,
          week: this.searchForm.week,
          weekday: this.searchForm.weekday,
          courseName: this.searchForm.courseName,
          communityId: this.communityId,
        };
        const res = await getCourseScheduleList(params);
        if (res && res.code === 0) {
          this.tableData = res.data || [];
          this.page.total = res.total || 0;
        } else {
          this.tableData = [];
          this.page.total = 0;
          this.$message.error(res.msg || "获取日程失败");
        }
      } catch (error) {
        console.error("获取日程列表失败:", error);
        this.$message.error("获取日程列表失败，请稍后重试");
        this.tableData = [];
        this.page.total = 0;
      } finally {
        this.loading = false;
      }
    },

    /**
     * 搜索
     */
    handleSearch() {
      this.page.current = 1;
      this.getList();
    },

    /**
     * 重置
     */
    handleReset() {
      this.searchForm = {
        week: "第1周",
        weekday: "",
        courseName: "",
      };
      this.handleSearch();
    },

    /**
     * 分页大小改变
     */
    handleSizeChange(val) {
      this.page.size = val;
      this.getList();
    },

    /**
     * 分页页码改变
     */
    handleCurrentChange(val) {
      this.page.current = val;
      this.getList();
    },

    /**
     * 获取时段的完整标签
     */
    getSectionLabel(sectionValue) {
      const sectionItem = this.sectionOptions.find(
        (item) => item.value === sectionValue,
      );
      return sectionItem ? sectionItem.label : sectionValue;
    },

    /**
     * 根据背景色计算文字颜色（黑/白）
     */
    getTextColor(backgroundColor) {
      if (!backgroundColor || backgroundColor === "#f9f9f9") return "#333";
      // 转换为RGB
      const hex = backgroundColor.replace("#", "");
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      // 计算亮度
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      return brightness > 128 ? "#333" : "#fff";
    },

    /**
     * 打开日程详情弹窗
     */
    openCourseDetail(course) {
      this.currentCourse = course;
      this.detailDialogVisible = true;
    },

    /**
     * 获取会议时间文本
     */
    getCourseTimeText(course) {
      if (!course || !course.section) return "无";

      const sections = course.section.split(",").map(Number);
      const startSection = Math.min(...sections);
      const endSection = Math.max(...sections);

      const startItem = this.sectionOptions.find(
        (item) => Number(item.value) === startSection,
      );
      const endItem = this.sectionOptions.find(
        (item) => Number(item.value) === endSection,
      );

      if (!startItem || !endItem) return "无";

      const startTime = startItem.label.split("(")[1].split("-")[0];
      const endTime = endItem.label
        .split("(")[1]
        .split("-")[1]
        .replace(")", "");

      return `${startTime} - ${endTime}`;
    },

    /**
     * 从URL解析文件名
     */
    getFileName(url) {
      if (!url) return "";
      const fileName = url.split("/").pop().split("?")[0];
      try {
        return decodeURIComponent(fileName);
      } catch (e) {
        return fileName;
      }
    },

    /**
     * 下载附件
     */
    downloadAttachment(course) {
      if (!course.url) {
        this.$message.warning("暂无附件可下载");
        return;
      }
      try {
        const link = document.createElement("a");
        link.href = course.url;
        link.download = this.getFileName(course.url) || "会议附件";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("下载附件失败：", error);
        this.$message.error("附件下载失败，请稍后重试");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.course-schedule-display-container {
  padding: 20px;
  background-color: #ffffff;

  .search-form {
    .el-form-item {
      margin-bottom: 0;
    }
  }

  .el-card {
    margin-bottom: 20px;
    border-radius: 0;
    box-shadow: none;
  }

  .schedule-card {
    background-color: #ffffff;
    border-radius: 0;
    overflow: hidden;
  }

  .schedule-title {
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    padding: 12px 0;
    background-color: #1677ff;
    color: #ffffff;
  }

  // 日程可视化样式
  .schedule-calendar {
    width: 100%;
    overflow-x: auto;
    background-color: #ffffff;
    border-radius: 0;

    // 顶部日期栏
    .calendar-top-header {
      display: flex;
      border-bottom: 1px solid #e8e8e8;
      background-color: #ffffff;

      .week-number-cell {
        width: 120px;
        padding: 10px 8px;
        text-align: center;
        font-weight: bold;
        border-right: 1px solid #e8e8e8;
        background-color: #f5f5f5;
        color: #333333;
      }

      .day-header-cell {
        flex: 1;
        padding: 10px 8px;
        text-align: center;
        border-right: 1px solid #e8e8e8;
        background-color: #ffffff;

        .day-name {
          font-size: 14px;
          margin-bottom: 2px;
          color: #333333;
        }

        .day-date {
          font-size: 12px;
          color: #999999;
        }
      }
    }

    .calendar-body {
      .time-row {
        display: flex;
        border-bottom: 1px solid #e8e8e8;
        height: 80px;

        .time-cell {
          width: 120px;
          padding: 10px 8px;
          text-align: center;
          border-right: 1px solid #e8e8e8;
          background-color: #f5f5f5;
          font-size: 12px;
          color: #666666;
          display: flex;
          flex-direction: column;
          justify-content: center;

          .section-number {
            font-weight: bold;
            margin-bottom: 2px;
          }

          .section-time {
            font-size: 11px;
          }
        }

        .course-cell {
          flex: 1;
          padding: 0;
          border-right: 1px solid #e8e8e8;
          height: 100%;
          position: relative;
          background-color: #ffffff;

          .course-block {
            position: absolute;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 12px;
            box-sizing: border-box;
            overflow: hidden;
            border: none;
            left: 0;
            top: 0;
            transition: all 0.2s ease;

            &:hover {
              transform: scale(0.98);
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
            }

            .course-name {
              font-size: 14px;
              font-weight: bold;
              margin-bottom: 4px;
              text-align: center;
            }

            .course-code {
              font-size: 12px;
              opacity: 0.9;
              text-align: center;
            }
          }
        }
      }
    }
  }

  // 颜色块样式
  .color-block {
    width: 30px;
    height: 30px;
    border-radius: 4px;
    display: inline-block;
    border: 1px solid #eee;
    margin: 0 auto;
  }

  // 表格样式
  ::v-deep .el-table th {
    background-color: #f5f5f5;
    border-color: #e8e8e8;
  }

  ::v-deep .el-table--striped .el-table__row--striped td {
    background-color: #fafafa;
  }

  ::v-deep .el-table td,
  ::v-deep .el-table th {
    border-color: #e8e8e8;
  }

  // 时段标签样式优化
  ::v-deep .el-tag {
    margin-bottom: 4px;
  }

  // 详情弹窗样式
  .course-detail-content {
    padding: 8px 0;

    .attachment-item {
      margin-top: 4px;
    }
  }

  .dialog-footer {
    text-align: center;
  }
}
</style>
